import React, { useRef, useState } from 'react';

/**
 * Drag-to-reorder image grid.
 *
 * @param {Object[]} items       - Array of { preview: string } objects
 * @param {Function} onReorder   - Called with (fromIndex, toIndex) when an image is dragged
 * @param {Function} onRemove    - Called with (index) when × is clicked
 */
const SortableImageGrid = ({ items, onReorder, onRemove }) => {
  const dragFrom = useRef(null);
  const [dragOver, setDragOver] = useState(null);

  return (
    <div className="flex flex-wrap gap-2">
      {items.map((item, index) => (
        <div
          key={item.id ?? item.preview ?? index}
          draggable
          onDragStart={() => { dragFrom.current = index; }}
          onDragEnter={() => setDragOver(index)}
          onDragOver={e => e.preventDefault()}
          onDragLeave={() => setDragOver(null)}
          onDrop={() => {
            if (dragFrom.current !== null && dragFrom.current !== index) {
              onReorder(dragFrom.current, index);
            }
            dragFrom.current = null;
            setDragOver(null);
          }}
          onDragEnd={() => { dragFrom.current = null; setDragOver(null); }}
          className={`relative w-16 h-16 flex-shrink-0 cursor-grab active:cursor-grabbing rounded-lg transition-all ${
            dragOver === index ? 'ring-2 ring-indigo-400 scale-95' : ''
          }`}
        >
          <img
            src={item.preview}
            alt={`${index + 1}`}
            className="absolute inset-0 w-full h-full object-cover rounded-lg border border-gray-200"
            draggable={false}
          />
          {index === 0 && (
            <span className="absolute top-1 left-1 bg-indigo-500 text-white text-xs px-1.5 py-0.5 rounded z-10">
              Main
            </span>
          )}
          <button
            type="button"
            onClick={() => onRemove(index)}
            className="absolute top-1 right-1 bg-black/60 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs hover:bg-red-600 transition-colors z-10"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default SortableImageGrid;
